/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GetGenitoreStudenteView } from './getGenitoreStudenteView';
import { GetPortafogliView } from './getPortafogliView';
import { GetRicaricaNoAggiornamentiView } from './getRicaricaNoAggiornamentiView';
import { GetScuolaNomePlessoIView } from './getScuolaNomePlessoIView';

export interface GetStudenteRicaricheView { 
    religione?: string;
    ricariche?: Array<GetRicaricaNoAggiornamentiView>;
    scuola?: GetScuolaNomePlessoIView;
    genitore?: GetGenitoreStudenteView;
    motivoEsenzione?: string;
    nome?: string;
    identificativoMenuExtra?: string;
    dietaAlternativa?: string;
    ordinamentoScolastico?: GetStudenteRicaricheView.OrdinamentoScolasticoEnum;
    isSospeso?: boolean;
    cognome?: string;
    sezione?: string;
    classe?: string;
    portafogli?: GetPortafogliView;
    isEsente?: boolean;
    codiceFiscale?: string;
    id?: string;
}
export namespace GetStudenteRicaricheView {
    export type OrdinamentoScolasticoEnum = 'SCUOLA_INFANZIA' | 'PRIMARIA';
    export const OrdinamentoScolasticoEnum = {
        SCUOLAINFANZIA: 'SCUOLA_INFANZIA' as OrdinamentoScolasticoEnum,
        PRIMARIA: 'PRIMARIA' as OrdinamentoScolasticoEnum
    };
}